import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useClipLogosPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canSee, canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      canSee: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.VIEW_CLIP_LOGO]),
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_LOGO]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_LOGO]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CLIP_LOGO]),
    }),
    [hasPlatformPermission]
  );

  return {
    canSee,
    canCreateLogo: canCreate,
    canUpdateLogo: canUpdate,
    canDeleteLogo: canDelete,
  };
};
